import { OrderManagementPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import BarChart10FilledIcon from "@redotech/redo-web/icon-old/bar-chart-10-filled.svg";
import BarChart10Icon from "@redotech/redo-web/icon-old/bar-chart-10.svg";
import { memo } from "react";

export const ShippingAnalyticsItem = memo(function ShippingAnalyticsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);

  const hasPermissionToViewOrderFulfillment = useHasPermission(
    OrderManagementPermissions.VIEW_ORDER_FULFILLMENT_ANALYTICS,
  );

  const newOmsEnabled = !!team.settings.outboundLabels?.newOmsEnabled;
  const showOrderFulfillment =
    hasPermissionToViewOrderFulfillment && newOmsEnabled;

  if (!showOrderFulfillment) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.analyticsOrderFulfillmentHref }}
      FilledIcon={BarChart10FilledIcon}
      friendlyName="Analytics"
      id="shipping-analytics"
      UnfilledIcon={BarChart10Icon}
    />
  );
});
